import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const SolutionScreen: React.FC = () => {
	return (
		<>
			<Row
				flexible
				mainAxisAlignment="center"
				crossAxisAlignment="center"
				className="relative py-14 max-md:px-5 md:py-36 bg-cover bg-[url('https://orlfaes.com/wp-content/uploads/Solucion-marina.jpg')] bg-center"
				responsiveCol
			>
				<div className="absolute bg-black/40 top-0 left-0 w-full h-full" />
				<Column
					className="w-full z-[1]"
					data-sal="zoom-out"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="extraBig"
						className="font-title max-md:text-4xl text-center !leading-none text-white"
					>
						Soluciones
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg max-md:order-last"
					src="https://otc.ulpgc.es/wp-content/uploads/cambio-climatico-1-scaled.jpg"
					alt="dos niñas con carteles dde cuidar el ambiente"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-left"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						1. Educación ambiental y participación comunitaria
					</TextComponent>
					<TextComponent variant="h5">
						Tacna ha iniciado <span className="font-semibold text-green-600">programas educativos</span> desde entidades como la{" "}
						<span className="text-cyan-600 font-bold">Dirección Regional de Educación</span>, promoviendo proyectos escolares de <span className="font-semibold">reciclaje</span>,{" "}
						<span className="font-semibold">cuidado del mar</span> y participación en <span className="font-semibold text-green-600">campañas de limpieza costera</span>. Organizaciones
						como <span className="text-cyan-600 font-bold">EcoMar Tacna</span>, así como colectivos estudiantiles y universidades (<span className="font-bold">UNJBG</span>), han
						desarrollado actividades de <span className="font-semibold text-green-600">reforestación</span> con plantas costeras y <span className="font-semibold">limpieza de playas</span>
						.
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-right"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						2. Proyectos de tratamiento de aguas residuales
					</TextComponent>
					<TextComponent variant="h5">
						El <span className="font-bold text-cyan-600">Proyecto de Mejoramiento del Sistema de Tratamiento de Aguas Residuales en Tacna</span>, impulsado por la{" "}
						<span className="font-semibold text-green-600">EPS Tacna</span> y el <span className="font-semibold text-green-600">Gobierno Regional</span>, busca reducir el{" "}
						<span className="font-semibold text-red-600">vertido de aguas contaminadas al mar</span>. Se ha construido infraestructura en{" "}
						<span className="text-cyan-600 font-bold">La Yarada Los Palos y Sama</span>, aunque aún <span className="font-semibold text-red-600">falta ampliar la cobertura</span>.
					</TextComponent>
				</Column>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg"
					src="https://diariocorreo.pe/resizer/v2/EPZUSIT6TJESZH6JUDRZTCHVKA.jpg?auth=c019138d214224701a271d580d392e12caf40cccd4f02964845424354b549e50&width=1200&height=682&quality=75&smart=true"
					alt="mujer señalando las aguas residuales"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg max-md:order-last"
					src="https://scontent.ftcq2-1.fna.fbcdn.net/v/t39.30808-6/484920515_992888312994772_8926066080665852523_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeEfTxS8KAQIy235lChpexvxMdiASLVzOSMx2IBItXM5I7AXH45MmWVb9_YCQkGsI0GzMsMXHOMOrmZoA-aof7iA&_nc_ohc=NGP1SOpu1eEQ7kNvwHcKF19&_nc_oc=AdlgcvVm5VJWCnhTL4xhvxFE74-WBQDi19WxyMUAQaFn-waVT2YcFor11laiumOHca0&_nc_zt=23&_nc_ht=scontent.ftcq2-1.fna&_nc_gid=kBaGD3JE-ATTe3naiO0kpA&oh=00_AfIaQH5orHy0F6w5ODRziqQmKmMg32CPWdjiH8qYhhHiyw&oe=682D71FF"
					alt="tirando peces de una red de pesca"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-left"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						3. Promoción de pesca responsable y vedas
					</TextComponent>
					<TextComponent variant="h5">
						El <span className="font-bold text-cyan-600">Ministerio de la Producción</span> ha establecido <span className="font-semibold text-red-600">vedas temporales</span> para
						especies vulnerables en la región sur. Además, se ha trabajado con <span className="font-semibold text-green-600">pescadores artesanales</span> en talleres de capacitación para
						usar <span className="font-semibold">artes de pesca sostenibles</span>. En <span className="font-bold text-yellow-600">2023</span>, más de{" "}
						<span className="font-bold text-green-600">150 pescadores artesanales</span> de la zona de <span className="text-cyan-600 font-bold">Ite y Boca del Río</span> participaron en
						jornadas de <span className="font-semibold text-green-600">sensibilización sobre prácticas sostenibles</span>, organizadas por{" "}
						<span className="font-bold text-cyan-600">PRODUCE</span> y la <span className="font-bold text-cyan-600">Municipalidad de Tacna</span>.
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] pb-5 md:pb-10"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-right"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						4. Monitoreo y fiscalización ambienta
					</TextComponent>
					<TextComponent variant="h5">
						La <span className="font-bold text-cyan-600">Dirección Regional de Salud Ambiental (DIGESA)</span> y <span className="font-bold text-cyan-600">OEFA</span> han realizado{" "}
						<span className="font-semibold text-green-600">operativos de inspección</span> en zonas del litoral. Se ha avanzado en la{" "}
						<span className="font-semibold">toma de muestras</span> para <span className="font-semibold text-red-600">monitorear la calidad del agua</span> y{" "}
						<span className="font-semibold text-red-600">prevenir riesgos</span> para la <span className="font-semibold text-green-600">pesca y el turismo</span>.
					</TextComponent>
				</Column>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg"
					src="https://remarco.org/wp-content/uploads/2021/07/Captura-mp-1.jpg"
					alt="persona inspeccion la arena"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Row>
		</>
	);
};
